import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=065ddcfc&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065ddcfc')) {
      api.createRecord('065ddcfc', component.options)
    } else {
      api.reload('065ddcfc', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=065ddcfc&", function () {
      api.rerender('065ddcfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22TGnFXLPQlRR/JS/comp/ImgFallback.vue"
export default component.exports